export enum RouteType {
  Default = 0,
  Redirect = 1,
  Exact = 2,
}
